import { getKey, callOpenAICompat } from './shared';
import { t } from '../modules/i18n';

export async function callXAI(model, prompt, signal, opts) {
  const key = getKey("xai");
  if (!key) throw new Error(t("err.nokey", { provider: "xAI" }));
  return callOpenAICompat("xAI", "https://api.x.ai/v1/chat/completions", key, model, prompt, signal, opts);
}
